/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://mxs4nxrwivalrfgmepbnoy3rba.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-west-1:39c4dde5-31ca-4751-aa16-e0d511146a41",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_wWtInsFU8",
    "aws_user_pools_web_client_id": "2cur8lcv6l6f5iiqhs24idf789",
    "oauth": {
        "domain": "dashboarde416f4d6-e416f4d6-staging.auth.eu-west-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://dashboard.empushy.com/signin,http://localhost:3000/signin",
        "redirectSignOut": "https://dashboard.empushy.com/,http://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "empushy-dashboard203001-staging",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
